/* Dagrox — theme.js
   UI behavior: FAQ toggle (native details), option swap, gallery thumb swap.
   Cart logic is in cart-drawer.js (Shopify AJAX API).
*/
(function () {
  'use strict';

  // INP helper: batch DOM reads/writes via rAF
  var _raf = function (fn) { requestAnimationFrame(fn); };

  // Gallery swipe carousel + thumbs + dots (PDP)
  var galleryTrack = document.querySelector('[data-gallery-track]');
  if (galleryTrack) {
    var slides = galleryTrack.querySelectorAll('.gallery-slide');
    var dots = document.querySelectorAll('[data-gallery-dots] .gallery-dot');
    var thumbs = document.querySelectorAll('.gallery-thumbs .thumb');

    function activateIndex(idx) {
      _raf(function () {
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('active', i === idx); });
      });
    }

    // Scroll handler: detect active slide via IntersectionObserver (fluid swipe)
    if ('IntersectionObserver' in window && slides.length > 0) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.5) {
            var idx = parseInt(e.target.getAttribute('data-slide-index'), 10);
            activateIndex(idx);
          }
        });
      }, { root: galleryTrack, threshold: [0.5, 0.9] });
      slides.forEach(function (s) { io.observe(s); });
    }

    function goTo(idx) {
      var slide = slides[idx];
      if (!slide) return;
      galleryTrack.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      activateIndex(idx);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.getAttribute('data-dot-index'), 10));
      });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.getAttribute('data-thumb-index'), 10));
      });
    });

    var currentIndex = 0;
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');

    function updateCurrentFromScroll() {
      if (!slides.length) return 0;
      var trackLeft = galleryTrack.scrollLeft;
      var slideW = slides[0].offsetWidth;
      currentIndex = Math.round(trackLeft / slideW);
      return currentIndex;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        updateCurrentFromScroll();
        if (currentIndex > 0) goTo(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        updateCurrentFromScroll();
        if (currentIndex < slides.length - 1) goTo(currentIndex + 1);
      });
    }

    // Video del prodotto (17/10/2026): parte muto quando la sua slide si vede davvero (dentro la galleria e nello schermo),
    // si ferma quando esce. Con preload none non scarica niente finché non serve.
    var videos = galleryTrack.querySelectorAll('[data-gallery-video] video');
    if (videos.length && 'IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target.querySelector('video');
          if (!v) return;
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            v.muted = true;
            var p = v.play();
            if (p && p.catch) p.catch(function () { /* autoplay bloccato: restano i controlli */ });
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: [0, 0.6] });
      videos.forEach(function (v) { var s = v.closest('.gallery-slide'); if (s) vio.observe(s); });
    }
  }

  // Quantity stepper (PDP)
  document.querySelectorAll('[data-pdp-qty]').forEach(function (group) {
    var input = group.querySelector('[data-pdp-qty-val]');
    var dec = group.querySelector('[data-pdp-qty-dec]');
    var inc = group.querySelector('[data-pdp-qty-inc]');
    if (!input) return;
    dec && dec.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value || '1', 10) - 1));
    });
    inc && inc.addEventListener('click', function () {
      input.value = Math.min(10, (parseInt(input.value || '1', 10) + 1));
    });
  });

  // Variant option swapper (PDP) — updates hidden variant id input
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variants = JSON.parse(form.dataset.variants || '[]');
    if (variants && !Array.isArray(variants)) variants = variants.variants || [];
    var optionSelectors = form.querySelectorAll('[data-option-selector]');
    var hiddenId = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare]');
    var addBtn = form.querySelector('[data-add-to-cart-btn]');
    var btnLabel = addBtn ? addBtn.querySelector('[data-btn-label]') : null;

    function getSelected() {
      var sel = {};
      form.querySelectorAll('[data-option-selector] .opt.selected').forEach(function (o) {
        sel[o.dataset.optName] = o.dataset.optValue;
      });
      return sel;
    }

    function findVariant() {
      var sel = getSelected();
      return variants.find(function (v) {
        return Object.keys(sel).every(function (k) {
          return v.options[k] === sel[k];
        });
      });
    }

    function applyVariant() {
      var v = findVariant();
      if (!v) return;
      if (hiddenId) hiddenId.value = v.id;
      if (priceEl) priceEl.textContent = v.priceFormatted;
      if (compareEl) {
        if (v.compareAtFormatted && v.compareAtCents > v.priceCents) {
          compareEl.textContent = v.compareAtFormatted;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (v.available) {
          addBtn.removeAttribute('disabled');
          if (btnLabel) btnLabel.textContent = 'Aggiungi al carrello · ' + v.priceFormatted;
        } else {
          addBtn.setAttribute('disabled', 'true');
          if (btnLabel) btnLabel.textContent = 'Esaurito';
        }
      }
    }

    optionSelectors.forEach(function (group) {
      group.querySelectorAll('.opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var name = btn.dataset.optName;
          group.querySelectorAll('[data-opt-name="' + name + '"]').forEach(function (b) {
            b.classList.remove('selected');
          });
          btn.classList.add('selected');
          applyVariant();
        });
      });
    });
  });

  // Homepage device card carousels
  document.querySelectorAll('[data-device-carousel]').forEach(function (carousel) {
    var slides = carousel.querySelectorAll('[data-device-slide]');
    if (slides.length < 2) return;
    var idx = 0;

    function showSlide(n) {
      slides.forEach(function (s, i) { s.classList.toggle('active', i === n); });
      idx = n;
    }

    var prev = carousel.querySelector('[data-device-prev]');
    var next = carousel.querySelector('[data-device-next]');
    if (prev) prev.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      showSlide(idx > 0 ? idx - 1 : slides.length - 1);
    });
    if (next) next.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      showSlide(idx < slides.length - 1 ? idx + 1 : 0);
    });
  });

  /* fix-newsletter-20260729: prima il submit veniva bloccato con preventDefault e il successo
     era finto — le email non arrivavano MAI a Shopify. Il form del footer è un vero
     {% form 'customer' %}: ora invia davvero e, al ritorno con ?customer_posted=true,
     mostriamo la stessa conferma di prima (stessa grafica, ma iscrizione reale). */
  if (/[?&]customer_posted=true/.test(location.search)) {
    document.querySelectorAll('.newsletter .ok').forEach(function (ok) {
      _raf(function () { ok.style.opacity = '1'; });
    });
  }

  // INP: mark FAQ toggles for instant visual feedback
  document.querySelectorAll('.faq-item summary, .info summary').forEach(function (s) {
    s.addEventListener('click', function () {
      _raf(function () { /* browser handles <details> toggle; rAF ensures paint */ });
    }, { passive: true });
  });
})();
